import { Box, Grid, InputBase, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import AnnouncementCard from '../../components/AnnouncementCard';
import CardContentTile from '../../components/CardContentTile/CardContentTile';
import DropAndSelect from '../../components/DropAndSelect/DropAndSelect';
import { fonts, themes } from '../../themes/themes';
import CustomModal from '../CustomModal/CustomModal';
import ModalHeader from '../CustomModal/ModalHeader';
import { RichEditor } from '../../../components/inputs/RichEditor';
interface ModalProps {
  isModalOpen?: boolean;
  closeModal?: any;
  setAnnounceViewData: any;
  trans?: any;
}
const ref = React.createRef();
const ViewAnnouncePresenter = ({
  isModalOpen,
  closeModal,
  setAnnounceViewData,
  trans,
}: ModalProps) => {
  return (
    <CustomModal
      isModalOpen={isModalOpen}
      modalHeight="755px"
      modalWidth="670px"
    >
      <ModalHeader
        modal={{ modal_title: trans('Announcement Details') }}
        closeModal={closeModal}
      />

      <Grid
        container
        style={{
          marginTop: '35px',
        }}
      >
        <Grid item xs={12} className="left-grid">
          <Grid container style={{ padding: '10px' }}>
            <Grid item xs={12}>
              <Typography
                style={{
                  fontFamily: fonts.fontFamily,
                  fontSize: fonts.title,
                  color: themes.blackDefault,
                  fontWeight: 'bold',
                  textAlign: 'center',
                }}
              >
                {trans('Messages')}
              </Typography>
              <div style={{ height: '100%' }}>
                <RichEditor
                  readOnly={true}
                  value={setAnnounceViewData?.message}
                />
              </div>

              <Typography
                style={{
                  fontFamily: fonts.fontFamily,
                  fontSize: fonts.title,
                  color: themes.blackDefault,
                  fontWeight: 'bold',
                  textAlign: 'center',
                  marginTop: '1em',
                }}
              >
                {setAnnounceViewData?.attachment ? (
                  <a href={setAnnounceViewData?.attachment}>
                    {trans('Click here to download')}
                  </a>
                ) : (
                  ''
                )}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={1}>
          {' '}
        </Grid>
      </Grid>
      <Box style={{ marginTop: '35px' }} />
    </CustomModal>
  );
};
export default ViewAnnouncePresenter;
